import apiTransactionSerial from '@/api/vo/transactionSerial';

const defaultState = () => ({
	listTransactionActivation: [],
	transactionActivationPagination: '',
	listTransactionRegistration: [],
	transactionRegistrationPagination: '',
	listTransactionUpgrade: [],
	transactionUpgradePagination: '',
	listTransactionRO: [],
	transactionROPagination: '',
	responseSuccess: {},
});

const state = defaultState();

const getters = {

};

const mutations = {

	setTransactionActivation(state, data) {
		state.listTransactionActivation = data.data;
		state.transactionActivationPagination = data.pagination;
	},
	setTransactionRegistration(state, data) {
		state.listTransactionRegistration = data.data;
		state.transactionRegistrationPagination = data.pagination;
	},
	setTransactionUpgrade(state, data) {
		state.listTransactionUpgrade = data.data;
		state.transactionUpgradePagination = data.pagination;
	},
	setTransactionRO(state, data) {
		state.listTransactionRO = data.data;
		state.transactionROPagination = data.pagination;
	},
	setSuccessTransaction(state, data) {
		state.responseSuccess = data
	},
};

const actions = {

	getTransactionActivation({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiTransactionSerial.getTransactionActivation(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setTransactionActivation', data.results)
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setTransactionActivation', { data: [], pagination: {} });
				reject()
			});
		});
	},

	getTransactionRegistration({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiTransactionSerial.getTransactionRegistration(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setTransactionRegistration', data.results)
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setTransactionRegistration', { data: [], pagination: {} });
				reject()
			});
		});
	},

	getTransactionUpgrade({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiTransactionSerial.getTransactionUpgrade(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setTransactionUpgrade', data.results)
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setTransactionUpgrade', { data: [], pagination: {} });
				reject()
			});
		});
	},

	getTransactionRO({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiTransactionSerial.getTransactionRO(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setTransactionRO', data.results)
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setTransactionRO', { data: [], pagination: {} });
				reject()
			});
		});
	},

	addTransactionSerial({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiTransactionSerial.addTransactionSerial(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					dispatch('success', data)
					commit('setSuccessTransaction', data.results)
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setSnackbar', {
					show: true,
					color: 'red darken-2',
					text: 'Terjadi kesalahan pada sistem, transaksi serial tidak dapat diproses.'
				}, { root: true });
				reject()
			});
		});
	},

	success({ commit }, data) {
		commit('setSnackbar', {
			show: true,
			color: 'green accent-4',
			text: data.message
		}, { root: true });
	},

	errorHandler({ commit }, response) {
		if (response.status !== undefined && response.status === 'unauthorized') {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: response.msg
			}, { root: true });
		} else {
			switch (response.error_code) {
				case 'validationError':
					commit('setErrorValidation', response.results.validationMessage)
					break;
					
				case 'ERROR':
					commit('setSnackbar', {
						show: true,
						color: 'red darken-2',
						text: response.message
					}, { root: true });
					break;
						
				default:
					commit('setSnackbar', {
						show: true,
						color: 'red darken-2',
						text: 'Terjadi Kesalahan pada sistem, hubungi administrator atau layanan mitra ' + (process.env.VUE_APP_CLIENT_INIT !== undefined) ? process.env.VUE_APP_CLIENT_INIT : 'perusahaan'
					}, { root: true });
					break;
			}
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};